import FreeTagIcon from "@/assets/svg/FreeTagIcon";

const FreeTag = ({ parentClass, textClass, fillIcon, label }) => (
  <div className={parentClass}>
    <FreeTagIcon width={18} height={18} color={fillIcon} />
    <p className={textClass}>{label}</p>
  </div>
);

export default FreeTag;
